module.exports = "<div class=\"pcoded\">\n   <!-- <ngx-loading [show]=\"loading\" [config]=\"{ backdropBorderRadius: '10px' }\"></ngx-loading> -->\n\t<div class=\"pcoded-container navbar-wrapper\">\n\t\t<app-header *ngIf=\"isLogin\"></app-header>\n\t\t<app-left-menu *ngIf=\"isLogin\"></app-left-menu>\n\t\t<div class=\"mainContainer\" [style.margin-left]=\"getMargin()\">\n\t\t  <router-outlet></router-outlet> \n\t\t</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main